import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import useSession from "Utils/Hooks/useSession";
import useVipAccountCache from "Utils/Hooks/useVipAccountCached";
import useVipApiFetcher from "Utils/Hooks/useVipApiFetcher";
import Loading from "./Loading";
import { PRODUCTTYPES } from "Utils/Constants";

/**
 * Displays a loading spinner instead of rendering children while fetching fresh VIP account data.
 * Caches the data after a successful response. Retrieve this data with the useVipAccountCache hook.
 * @param {Loading.defaultProps} props
 * @returns
 */
const LoadVipAccount = (props) => {
  const { session } = useSession();
  const productType = session?.patronProductType === PRODUCTTYPES.PREFERRED ? 'VIP Preferred' : 'VIP Online';
  //document.title = "LVA" + productType;
  const vipApi = useVipApiFetcher();
  const { setVipAccount } = useVipAccountCache();
  const [isLoading, setIsLoading] = useState(true);
  const history = useHistory();

  // Fetch fresh vipAccount data on first render.
  useEffect(() => {
    if (!vipApi.ready) return;
    let mounted = true;
    (async () => {
      const response = await vipApi.fetch("/api/accounts");
      switch (response.status) {
        case 200:
          const accountData = await response.json();

          // Almost certain this isn't needed
          // await vipApi.fetch("/api/bank")
          //   .then((res) => res.json())
          //   .then((data) => {
          //     accountData['bankAccounts'] = data;
          //   })
          //   .catch((err) => {
          //     console.warn(err);
          //   });

          if (!mounted) return;
          setVipAccount(accountData);
          setIsLoading(false);
          break;
        case 401:
          console.error(response);
          if (!mounted) return;
          setIsLoading(false);
          history.push("/expired");
          break;
        default:
          console.error(response);
          const message = await response.json();
          if (!mounted) return;
          setIsLoading(false);
          history.push({
            pathname: '/error', state: {
              message,
              buttonText: `CONTINUE TO ${session.operatorName.toUpperCase()}`,
              onClickClose: true
            }
          });
      }
    })();
    // Cleanup
    return () => { mounted = false };
  }, [vipApi.ready]);

  return (
    <>
      {isLoading ? <Loading {...props} /> : props.children}
    </>
  );
}
export default LoadVipAccount;
